import React from 'react';
import { getLocaleUTCDateString } from '../../shared/lib/time';
import { getPropertyConfiguration } from '../../shared/lib/propertyConfig';
import { BareSailingDay, SailingDay, SailingDayTemplateFragments } from '@go-shared/types/sailing';
import TemplateGlanceButton from './TemplateGlanceButton';
import { BubbleBadge, BubbleButton } from './BubbleUI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DayMarkersButton } from './DayMarkersButton';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';

export interface SailingDayHeaderProps {
  day?: BareSailingDay | SailingDay;
  location?: string;
  date?: Date;
  templateName?: string;
  templateHistory?: SailingDayTemplateFragments;
  templateFragments?: SailingDayTemplateFragments;
  isPublished?: boolean;
  dayLocked: boolean;
  onTemplateFragmentsClick?: () => void;
  onTemplateNameClick?: () => void;
}

const DAILY_PLANNER_HEADER_HEIGHT = 40;

export default function SailingDayHeader(props: SailingDayHeaderProps) {
  const { activeProperty } = useActiveProperty();

  const {
    day,
    location,
    date,
    templateName,
    templateHistory,
    templateFragments,
    onTemplateFragmentsClick,
    dayLocked,
    isPublished,
  } = props;

  return (
    <div
      className="flex flex-row items-center -mx-2 px-4"
      style={{ height: `${DAILY_PLANNER_HEADER_HEIGHT}px` }}
    >
      {dayLocked && (
        <div className="px-2 text-base">
          <FontAwesomeIcon icon="lock" className="text-smoke" />
        </div>
      )}
      {date && (
        <div className="px-2 text-base">
          <span className="text-navy-darkest font-bold">{getLocaleUTCDateString(date)}</span>
        </div>
      )}
      {isPublished !== undefined && (
        <div className="px-2 mt-1">
          <BubbleBadge
            showIcon
            iconName={isPublished ? 'paper-plane' : 'pencil'}
            variant={isPublished ? 'emerald' : 'dirt'}
          >
            {isPublished ? 'Published' : 'Draft'}
          </BubbleBadge>
        </div>
      )}
      {location && getPropertyConfiguration(activeProperty.type, 'showPort') && (
        <div className="px-2 text-base">
          <span className="text-xs uppercase text-slate font-bold mr-1">LOCATION:</span>
          <span className="text-navy-darkest font-bold">{location}</span>
        </div>
      )}
      {templateName && (
        <div className="px-2">
          <BubbleButton
            variant="slate"
            className="p-0-i font-bold"
            inverse
            onClick={props.onTemplateNameClick}
          >
            <span className="underline text-velvet-darkest font-bold">{templateName}</span>
          </BubbleButton>
        </div>
      )}
      {onTemplateFragmentsClick && (
        <div className="px-2 mt-1">
          <TemplateGlanceButton
            locked={dayLocked}
            templateHistory={templateHistory}
            templateFragments={templateFragments}
            onClick={onTemplateFragmentsClick}
          />
        </div>
      )}
      <DayMarkersButton sailingDay={day} noDefaultText />
    </div>
  );
}
